import {
  type Attribute,
  type ColorTemperature,
  type FixtureType,
  type LampBase,
  type LampType,
  type LightSource,
} from '#packages/data-collection/models/audit-lighting-type-form';

export const LightSourceLabel: Record<LightSource, string> = {
  incandescent: 'Incandescent',
  fluorescent: 'Fluorescent',
  compact_fluorescent: 'Compact Fluorescent',
  halogen: 'Halogen',
  metal_halide: 'Metal Halide',
  high_pressure_sodium: 'High Pressure Sodium',
  led: 'LED',
};

export const LampTypeLabel: Record<LampType, string> = {
  '2pin_pl': '2-Pin PL',
  '4pin_pl': '4-Pin PL',
  t5_4ft: "T5 (4')",
  t8_4ft: "T8 (4')",
  t12_4ft: "T12 (4')",
  t8_1ft: "T8 (1')",
  t8_18in: 'T8 (18")',
  t8_2ft: "T8 (2')",
  t8_3ft: "T8 (3')",
  t8_8ft: "T8 (8')",
  t8_u: 'T8 (U)',
  t12_8ft: "T12 (8')",
  t12_u: 'T12 (U)',
  a15: 'A15',
  a19: 'A19',
  a21: 'A21',
  br30: 'BR30',
  br38: 'BR38',
  br40: 'BR40',
  candle: 'Candle',
  g25: 'G25',
  g40: 'G40',
  g100: 'G100',
  par20: 'PAR20',
  par30: 'PAR30',
  par38: 'PAR38',
  r20: 'R20',
  r30: 'R30',
  r40: 'R40',
  mr16: 'MR16',
  t3: 'T3',
  x: 'x',
  retrofit_kit: 'Retrofit Kit',
  exit: 'Exit',
};

export const LampBaseLabel: Record<LampBase, string> = {
  b4_5: 'B4.5',
  b15: 'B15',
  e12: 'E12 (Candle)',
  e26: 'E26 (Medium)',
  e39: 'E39 (Mogul)',
  g23: 'G23',
  g24d: 'G24d',
  g24q: 'G24q',
  gu5_3: 'GU5.3',
  gu10: 'GU10',
  gu24: 'GU24',
  gx23: 'GX23',
  gx24q: 'GX24q',
  r7s: 'R7s',
  med_bipin: 'Med BiPin',
  single_pin: 'Single Pin',
  x: 'x',
  unknown: '?',
};

export const FixtureTypeLabel: Record<FixtureType, string> = {
  strip: 'Strip',
  troffer: 'Troffer',
  pot_light: 'Pot Light',
  keyless: 'Keyless',
  high_bay: 'High Bay',
  low_bay: 'Low Bay',
  marine: 'Marine',
  flood: 'Flood',
  panel: 'Panel',
  track: 'Track',
  sconce: 'Sconce',
  under_cabinet: 'Under Cabinet',
  cylinder: 'Cylinder',
  wall_pack: 'Wall Pack',
  pole_light: 'Pole Light',
  unknown: '?',
};

export const AttributeLabel: Record<Attribute, string> = {
  cage: 'Cage',
  open: 'Open',
  wrap: 'Wrap',
  circular: 'Circular',
  dome: 'Dome',
  globe: 'Globe',
  linear: 'Linear',
  square: 'Square',
  full_cutoff: 'Full Cut-off',
  gimble: 'Gimble',
  half_cutoff: 'Half Cut-off',
  horizontal_bulb: 'Horizontal Bulb',
  up_down: 'Up/Down',
  vertical_bulb: 'Vertical Bulb',
  architectural: 'Architectural',
  dimmable: 'Dimmable',
  valence: 'Valence',
  vanity: 'Vanity',
  metric: 'Metric',
  shoebox: 'Shoebox',
  cobra: 'Cobra',
  yoke: 'Yoke',
  knuckle: 'Knuckle',
};

export const ColorTemperatureLabel: Record<ColorTemperature, string> = {
  '2400k': '2400 K',
  '2700k': '2700 K',
  '3000k': '3000 K',
  '3500k': '3500 K',
  '4000k': '4000 K',
  '4500k': '4500 K',
  '5000k': '5000 K',
  '6000k': '6000 K',
};
